// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2MlAm","label":"Section_label__2IotW","contentWrap":"Section_contentWrap__cFidr","footer":"Section_footer__12bMz","footerInner":"Section_footerInner__35kqK"};